<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">News details</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <div>
      <div class="row custom-upper-space">
        <div>
          <div class="table-responsive details-table">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td>
                    <div class="d-flex justify-content-between">
                      <div>
                        <span class="datetext"> {{ newsList.subject }} </span>
                      </div>
                      <div>
                        <span class="subject-txt"
                          >{{ newsList.date | date : 'EEE, d MMM YYYY' }}
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="news-container">
                      <div [innerHTML]="newsList?.description"></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
  </div>
</div>
